/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import * as actions from '../../types/roles.type';

export const getRoles = (data: any) => ({
  type: actions.GET_ROLES,
  payload: data,
});

export const getRolesSuccess = (data: any) => ({
  type: actions.GET_ROLES_SUCCESS,
  payload: data,
});

export const getRolesFailure = (error: any) => ({
  type: actions.GET_ROLES_FAILURE,
  payload: error,
});

export const updateRoles = (data:any) => ({
  type: actions.UPDATE_ROLES,
  payload: data,
});

export const updateRolesSuccess = (data:any) => ({
  type: actions.UPDATE_ROLES_SUCCESS,
  payload: data,
});

export const updateRolesFailure = (error: any) => ({
  type: actions.UPDATE_ROLES_FAILURE,
  payload: error,
});

export const deleteRoles = (data:any) => ({
  type: actions.DELETE_ROL,
  payload: data,
});

export const deleteRolesSuccess = (data:any) => ({
  type: actions.DELETE_ROL_SUCCESS,
  payload: data,
});

export const deleteRolesFailure = (error: any) => ({
  type: actions.DELETE_ROL_FAILURE,
  payload: error,
});

export const updateCurrentRoles = (data:any) => ({
  type: actions.UPDATE_CURRENT_ROLES,
  payload: data,
});

export const updateRolOnList = (data:any) => ({
  type: actions.UPDATE_ROL_ON_LIST,
  payload: data,
});

export const cleanRolesErrors = () => ({
  type: actions.CLEAN_ROLES_ERRORS,
});
